import bg from "../resources/images/backgrounds/bg1.jpg";
import bg2 from "../resources/images/backgrounds/bg2.jpg";
function Background1() {
    return (
        <img src={bg2} className="vh-100 w-100 banner-image " style={{ position: "fixed", zIndex: "-2" }} />

    );
}

export default Background1;